export default __webpack_public_path__ + "static/media/forest_color.fc7243be.png";